import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { from } from 'rxjs';
import { GalleryMetaImageUploadService } from '../../../services/gallery-meta-image-upload.service';
import { GalleryService } from '../../../services/gallery.service';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { GalleryTeaserUrlPipe } from '../../../shared/pipes/gallery-teaser-url.pipe';

@Component({
  selector: 'app-editable-gallery-teaser-icon',
  imports: [GalleryTeaserUrlPipe, ButtonDirective, SvgComponent, LoadingIndicatorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './editable-gallery-teaser-icon.component.html',
  styleUrl: './editable-gallery-teaser-icon.component.scss',
})
export class EditableGalleryTeaserIconComponent {
  gallery = input.required<GalleryDto>();
  shape = input.required<'round' | 'rounded-rectangle'>();
  shadow = input<boolean>();
  private galleryService = inject(GalleryService);
  private galleryMetaImageUploadService = inject(GalleryMetaImageUploadService);
  loading = signal(false);

  async uploadTeaserEvent(target: EventTarget) {
    const files = (target as HTMLInputElement).files;
    this.uploadTeaser(files[0]);
  }

  async uploadTeaser(file: File) {
    if (!file) return;
    this.loading.set(true);
    from(this.galleryMetaImageUploadService.upload(file, this.gallery(), 'teaser')).subscribe(() => {
      this.loading.set(false);
    });
  }

  async removeTeaser() {
    await this.galleryService.updateGallery(this.gallery().id, {
      teaser: {
        ...this.gallery().teaser,
        uuid: null,
        ext: null,
        format: null,
      },
    });
  }
}
